export default [
  {
    path: '/about/mileage',
    component: () => import('../../views/about/Mileage.vue'),
    name: 'mileage',
    meta: {
      auth: 0,
      title: '预估里程',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/about/quick-help',
    component: () => import('../../views/about/QuickHelp.vue'),
    name: 'quick-help',
    meta: {
      auth: 0,
      title: '帮助',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/about/quick-help-detail',
    component: () => import('../../views/about/QuickHelpDetail.vue'),
    name: 'quick-help-detail',
    meta: {
      auth: 0,
      title: '如何添加到桌面',
      backgroundClass: 'bg-gray',
    },
  },
];
